import { render, staticRenderFns } from "./modalCambiarLogo.vue?vue&type=template&id=fa9be73c"
import script from "./modalCambiarLogo.vue?vue&type=script&lang=js"
export * from "./modalCambiarLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports